module.exports = __webpack_public_path__ + "static/media/app-icon.7c6fb809.jpg";